import { faLocationDot } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { SingleLineWithEllipsis } from '@b-stock/fe-core/bstock-next/components'

import { useCardLocation } from '@/hooks/location/useCardLocation'
import type { SearchResult } from '@/queries/listingSearchQuery'

const Body = styled.div`
  display: flex;
  justify-items: flex-end;
  align-items: center;
  gap: 0.25rem;
  overflow: hidden;
`

const Icon = styled(FontAwesomeIcon)`
  height: 0.75rem;
`

export const Location = ({ listing }: { listing: SearchResult }) => {
  const displayedLocation = useCardLocation({
    city: listing.sellerCity,
    provinceCode: listing.provinceCode,
    countryCode: listing.countryCode,
  })
  return (
    <Body>
      <Icon icon={faLocationDot} />
      <SingleLineWithEllipsis data-testid="listing-location">
        {displayedLocation}
      </SingleLineWithEllipsis>
    </Body>
  )
}
